import { type ReactNode } from 'react';
import { TileHeader, TileTabsRow } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import { TABS } from './constants';
import LeagueTableTab from './LeagueTableTab';

interface ILeagueTableTileHeaderProps {
  children?: ReactNode,
}

const LeagueTableTileHeader = ({ children }: ILeagueTableTileHeaderProps) => (
  <>
    <TileHeader
      title={ <Title title="League Tables" /> }
      hideTitleOnDesktop
      noDesktopBottomBorder
      dataTest="leagueTableTileHeader"
    >
      { children }
    </TileHeader>
    <TileTabsRow dataTest="leagueTableTabs">
      { Object.values(TABS).map((tabItem) => (
        <LeagueTableTab
          key={ tabItem.path }
          path={ tabItem.path }
          title={ tabItem.title }
          typeCompany={ tabItem.typeCompany }
          dataTest={ tabItem.dataTest }
        />
      )) }
    </TileTabsRow>
  </>
);

export default LeagueTableTileHeader;
